import QuizProductCard from "./QuizProductCard";
import { recipeDescriptionFor } from "./productCopy";

// This matches the shape we build in ResultsMealSelection (LocalRecipe)
type RecipeCardRecipe = {
    id: string;
    title: string;
    image?: string;
    grams: number;
    variantId: string;
    price: number;
    variant?: any;
    description?: string;
};

type Props = {
    recipe: RecipeCardRecipe;
    count: number;
    onIncrement: () => void;
    onDecrement: () => void;
};

export default function RecipeCardCompact({
    recipe,
    count,
    onIncrement,
    onDecrement,
}: Props) {
    return (
        <QuizProductCard
            image={recipe.image}
            title={recipe.title}
            subtitle={`${recipe.grams}G`}
            description={recipe.description ?? recipeDescriptionFor(recipe.title)}
            count={count}
            onIncrement={onIncrement}
            onDecrement={onDecrement}
            accentSeed={recipe.variantId}
        />
    );
}
